import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global navigation tracker that maintains history across the entire app
 * This component should be mounted once at the root level to track all navigation
 */
export function NavigationTracker() {
  const location = useLocation();
  const historyRef = useRef<string[]>([]);

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Don't add duplicate consecutive entries
    if (historyRef.current[historyRef.current.length - 1] !== currentPath) {
      historyRef.current.push(currentPath);
      
      // Keep only last 10 entries to prevent memory issues
      if (historyRef.current.length > 10) {
        historyRef.current.shift();
      }
      
      // Store in sessionStorage so it persists across component remounts
      sessionStorage.setItem('navigationHistory', JSON.stringify(historyRef.current));
    }
  }, [location.pathname]);

  // Initialize from sessionStorage on mount
  useEffect(() => {
    const stored = sessionStorage.getItem('navigationHistory');
    if (stored) {
      try {
        historyRef.current = JSON.parse(stored);
      } catch (e) {
        historyRef.current = [location.pathname];
      }
    } else {
      historyRef.current = [location.pathname];
    }
  }, []);

  return null; // This component doesn't render anything
}
